import useSWR from "swr";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createStoreCurrenciesUrl } from "@is/services";
import { Currency } from "@is/types";

export const useStoreCurrencies = () => {
  const { setApiHeaders } = useManageApiHeaders();

  setApiHeaders();

  const url = createStoreCurrenciesUrl();

  const { data, error, isLoading } = useSWR(url, api.get);

  return {
    currencies: data as Currency[],
    isLoading,
    error,
  };
};
